import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "../HorizontalBarChart/HorizontalBarChart.css";

const data = [
  { ReportCount: 5000, Reports: "Report Under Process", legend: "Process" },
  { ReportCount: 3000, Reports: "Report Under Review", legend: "Review" },
];

const CustomBar = (props) => {
  const { fill, x, y, width, height } = props;
  const radius = 8; // Rounded corner radius
  const effectiveRadius = Math.min(radius, height / 2); // Ensures radius doesn't exceed bar height

  return (
    <path
      d={`M${x},${y}
         h${width - effectiveRadius}
         a${effectiveRadius},${effectiveRadius} 0 0,1 ${effectiveRadius},${effectiveRadius}
         v${height - effectiveRadius * 2}
         a${effectiveRadius},${effectiveRadius} 0 0,1 -${effectiveRadius},${effectiveRadius}
         h-${width - effectiveRadius}
         v-${height}
         Z`}
      fill={fill}
    />
  );
};

const colors = ["#5662be", "#efc58a"];

const HorizontalBarChart = () => {
  return (
    <>
      <section className="-full-section">
        <div className="full-horizontal-container">
          <div className="full-horizontal-header">
            <h1>Report Status Overview: Under Process vs. Under Review <sub style={{color: "blue"}}>(Horizontal bar chart)</sub></h1>
          </div>

          <div className="full-horizontal-parent">
            <div className="full-horizontal-chart-container">
              <ResponsiveContainer width="100%" height={400}>
                <BarChart
                  layout="vertical" // Horizontal bars
                  data={data}
                  margin={{
                    top: 0,
                    right: 30,
                    bottom: 40,
                    left: -23,
                  }}
                >
                  <CartesianGrid
                    stroke="#d6d6d6"
                    strokeDasharray="0 0"
                    horizontal={false}
                    vertical={true}
                  />
                  <XAxis
                    type="number"
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated font size and color for ticks
                    label={{
                      value: "Report Count", // Title of the X-axis
                      position: "insideLeft", // Position of the title
                      offset: 0, // Adjusts the position of the label
                      style: { fontSize: "16px", fill: "#999" }, // Updated font size and color
                      dy: 40,
                    }}
                  />
                  <YAxis
                    dataKey="Reports"
                    type="category"
                    width={200}
                    tick={{ fontSize: "16px", fill: "#999" }} // Updated font size and color for ticks
                  />
                  <Tooltip
                    cursor={{ fill: "transparent" }}
                    labelStyle={{
                      fontSize: "16px", // Updated tooltip label font size
                      color: "#000", // Updated tooltip label color
                    }}
                    itemStyle={{
                      fontSize: "16px", // Updated tooltip item font size
                      color: "#999", // Updated tooltip item color
                    }}
                    formatter={(value) => [`${value}k`, "Reports Count"]}
                  />
                  <Bar
                    dataKey="ReportCount"
                    shape={(props) => {
                      // Pass dynamic color based on the index of the data
                      const color = colors[props.index % colors.length];
                      return <CustomBar {...props} fill={color} />;
                    }}
                    barSize={45}
                  />
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="full-horizontal-legend-table">
              <table>
                <thead>
                  <tr className="full-thead">
                    <td>Legend</td>
                    <td>Name</td>
                    <td>Count</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#5662be" }}
                      ></i>
                    </td>
                    <td>Process</td>
                    <td>Total Report :</td>
                    <td>43732213</td>
                  </tr>
                  <tr>
                    <td>
                      <i
                        class="fa-solid fa-circle"
                        style={{ color: "#efc58a" }}
                      ></i>
                    </td>
                    <td>Review</td>
                    <td>Report Review :</td>
                    <td>43732213</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default HorizontalBarChart;
